
import { React, useState } from "react";
import { Typography, Grid } from "@mui/material";
import "./styles.css";

export default function LabourFee(props) {
  const [labourFee, setLabourFee] = useState(false);
  return (
    <Grid
      className="labour-fee"
      display="flex" flexDirection='column'
      sx={{ boxShadow: "0px 3px 6px #7E7E7E29" }}
    >
      <Grid container spacing={1} pt={1} pb={1} >
        <Grid item xs={9}>
          <span className="summaryLabelCls"> Labour fee</span>
          <div
            className="insideCntCls"
            onClick={() => setLabourFee(!labourFee)}
          >
            Labour fee calculation details
          </div>
        </Grid>
        <Grid item xs={3}>
          <span className="summaryValueCls">
            R 38.00
          </span>
        </Grid>
        <Grid
          container
          ml={3}
          mt={1}
          display="flex"
          flexDirection="column"
          width="100%"
          mr={7}
        // border="1px solid red"
        >
          <Grid
            item
            // xs={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <span className="labourFee">Labour fee</span>
            <span className="labourFee">
              <b>R 28.00</b>
            </span>
          </Grid>
          <Grid
            item
            // xs={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <span className="labourFee">Call out fee</span>
            <span className="labourFee">
              <b>R 02.00 </b>
            </span>
          </Grid>
          <Grid
            item
            // xs={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <span className="labourFee">TOTAL</span>
            <span className="labourFee">
              <b>
                R 30.00
              </b>
            </span>
          </Grid>
        </Grid>

        <Grid item xs={8}>
          <span className="summaryLabelCls">Total Hours</span>
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={3}>
          <span className="summaryValueCls">
            2.5 hrs
          </span>
        </Grid>

        <Grid item xs={8}>
          <span className="summaryLabelCls">DigiAqua Service charge</span>
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={3}>
          <span className="summaryValueCls">
            {" "}
            R 10.00
          </span>
        </Grid>
      </Grid>

      <Typography
        borderTop="1px dashed #3C8C9E;"
        borderBottom=".5px solid #3C8C9E;"
        fontSize="20px"
        id="jcsb"
        pb={1}
        pt={1}
      >
        <Grid container>
          <Grid item xs={8}>
            <span
              className="summaryLabelCls"
              style={{ fontSize: "18px", fontWeight: "bold" }}
            >
              TOTAL
            </span>
          </Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={3}>
            <span
              className="summaryValueCls"
              style={{ fontSize: "18px", fontWeight: "bold" }}
            >
              {" "}
              R 104.00
            </span>
          </Grid>
        </Grid>
      </Typography>
    </Grid>
  );
}
